export enum TransitionState {
  Idle,
  Loading,
  InfiniteLoading
}
